export default __webpack_public_path__ + "static/media/ic-blacklist-active.81fb7f08.webp";